import { buildUrl, isNonEmptyArray, matchList, ONE_KIBI_BYTE, safeTruncate, tryJsonParse } from '@datadog/browser-core';
/**
 * arbitrary value, byte precision not needed
 */
var GRAPHQL_PAYLOAD_LIMIT = 32 * ONE_KIBI_BYTE;
export function extractGraphQlMetadata(request, graphQlConfig) {
  var metadata = extractGraphQlRequestMetadata(request, graphQlConfig.trackPayload);
  if (!metadata) {
    return;
  }
  if (graphQlConfig.trackResponseErrors && request.responseBody) {
    var responseErrors = parseGraphQlResponse(request.responseBody);
    if (responseErrors) {
      metadata.error_count = responseErrors.length;
      metadata.errors = responseErrors;
    }
  }
  return metadata;
}
export function parseGraphQlResponse(responseText) {
  var response = tryJsonParse(responseText);
  if (!response || typeof response !== 'object') {
    return;
  }
  var responseObj = response;
  if (!isNonEmptyArray(responseObj.errors)) {
    return;
  }
  var errors = responseObj.errors.map(function (error) {
    var _a;
    var graphqlError = {
      message: error.message,
      path: error.path,
      locations: error.locations,
      code: (_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code
    };
    return graphqlError;
  });
  return errors;
}
export function findGraphQlConfiguration(url, configuration) {
  return configuration.allowedGraphQlUrls.find(function (graphQlOption) {
    return matchList([graphQlOption.match], url);
  });
}
export function extractGraphQlRequestMetadata(request) {
  var trackPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var rawMetadata;
  if (request.method === 'POST') {
    rawMetadata = extractFromBody(request.requestBody);
  } else if (request.method === 'GET') {
    rawMetadata = extractFromUrlQueryParams(request.url);
  }
  if (!rawMetadata) {
    return;
  }
  return sanitizeGraphQlMetadata(rawMetadata, trackPayload);
}
function extractFromBody(requestBody) {
  if (!requestBody || typeof requestBody !== 'string') {
    return;
  }
  var graphqlBody = tryJsonParse(requestBody);
  if (!graphqlBody) {
    return;
  }
  return {
    query: graphqlBody.query,
    operationName: graphqlBody.operationName,
    variables: graphqlBody.variables ? JSON.stringify(graphqlBody.variables) : undefined
  };
}
function extractFromUrlQueryParams(url) {
  var searchParams = buildUrl(url).searchParams;
  var variablesParam = searchParams.get('variables');
  var variables = variablesParam && tryJsonParse(variablesParam) !== undefined ? variablesParam : undefined;
  return {
    query: searchParams.get('query') || undefined,
    operationName: searchParams.get('operationName') || undefined,
    variables: variables
  };
}
function sanitizeGraphQlMetadata(rawMetadata, trackPayload) {
  var operationType;
  var payload;
  var variables;
  if (rawMetadata.query) {
    var trimmedQuery = rawMetadata.query.trim();
    operationType = getOperationType(trimmedQuery);
    if (trackPayload) {
      payload = safeTruncate(trimmedQuery, GRAPHQL_PAYLOAD_LIMIT, '...');
    }
  }
  if (rawMetadata.variables) {
    variables = rawMetadata.variables;
  }
  return {
    operationType: operationType,
    operationName: rawMetadata.operationName,
    variables: variables,
    payload: payload
  };
}
function getOperationType(query) {
  var _a;
  return (_a = query.match(/^\s*(query|mutation|subscription)\b/i)) === null || _a === void 0 ? void 0 : _a[1];
}